<template>
  <div>
    <!--el-row默认左右margin: -25 导致出现水平滚动条 不美观 故设为0-->
    <el-row justify="center" class="row-bg" :gutter="gutter" style="margin: 0 0 20px 0" v-for="r in row" :key="r">
      <template v-for="c in col"><!--v-for v-if同时使用 后者优先级更高 导致if访问不到for中的变量-->
        <!--v-for 从1 not 0开始-->
        <el-col v-if="inRange(r,c)" :span="span">
          <el-card :body-style="{ padding: '0px'}">
            <el-image style="aspect-ratio: 1/1" fit="cover"
                      :src="getImageUrl(r,c)"
                      :preview-src-list="srcList"
                      :initial-index="getIndex(r,c)"
                      hide-on-click-modal
                      loading="lazy"
                      class="image"
            /><!--lazy懒加载导致横竖屏切换时(v-for重新渲染)，有些图片不加载，推测是没有指定key-->
            <!--改用loading="lazy"调用浏览器原生能力，效果更好，横竖屏切换不会重新加载图片，不会出现渲染错误-->
            <!--或者使用:key=随机值强制节点重新渲染，但是性能差-->
            <div style="padding: 12px">
              <EditLabel :text="getImageTitle(r,c)" @edited="titleEdited(r,c,$event)" :tool-tip-disable="Mobile.on"
                         class="ellipsis editLabel"/>
              <div class="bottom">
                <time class="time">{{ getItem(r, c)['lastModify'] }}</time>
                <el-popconfirm title="Are you sure to delete this?" @confirm="window.alert('del')">
                  <template #reference>
                    <el-button text class="button">Delete</el-button>
                  </template>
                </el-popconfirm>
              </div>
            </div>
          </el-card>
        </el-col>
      </template>
    </el-row>
    <el-backtop :right="50" :bottom="isLandscapeMobile ? 50 : 100" :visibility-height="500"/><!--处理Mobile横屏-->
    <div style="display: flex; justify-content: center;margin-bottom: 20px">
      <el-pagination background layout="prev, pager, next" :total="this.list.length" :page-size="50"
                     @current-change="window.alert($event)"/>
    </div>
  </div>
</template>

<script>
import axiosIns from "@/utils/axiosInstance";
import * as tool from "@/utils/tool"
import EditLabel from "@/components/EditLabel.vue";
import {ElMessage} from "element-plus";

export default {
  name: "MultiViewer",
  components: {
    EditLabel
  },
  // inject: ['baseUrl'],
  data() {
    return {
      list: [],
      srcList: [],
      col: 5,
      span: 4,
      gutter: 50,
      tool,
      window,
      page: 1,
      Mobile: {
        on: false,
        isVertical: true
      }
    }
  },
  methods: {
    titleEdited(r, c, newTitle) {
      let obj = this.getItem(r, c)
      let oldName = obj.name
      let suffix = tool.getSuffix(oldName)
      let newName = newTitle + suffix
      if (newName !== oldName) {
        axiosIns.post('/rename', {
          oldName: oldName,
          newName: newName
        }).then((res) => {
          if (!res.data.state) throw new Error("rename failed")
          obj.name = newName
          ElMessage.success('Rename Success')
        }).catch((error) => {
          obj.name = oldName //改回来
          ElMessage.error('Oops,' + error)
        })
      }
    },
    getImageList() {
      axiosIns.get("/getImageList").then(res => {
        this.list = res.data["imageList"]
        console.assert(this.list, "list == null")
        this.list.sort((a, b) => { //按照日期排序 //> 0: a在b后; < 0: a在b前; === 0: 保持a和b的顺序
          if (new Date(a.lastModify) < new Date(b.lastModify))
            return -1
          else
            return 1
        })
        this.srcList = []
        for (const item of this.list) {
          this.srcList.push(item.uri)
        }
      })
    },
    inRange(r, c) {
      return this.getIndex(r, c) < this.list.length
    },
    getIndex(r, c) {
      return (r - 1) * this.col + (c - 1)
    },
    getItem(r, c) {
      let i = this.getIndex(r, c)
      return i < this.list.length ? this.list[i] : null
    },
    getImageUrl(r, c) {
      // return this.baseUrl + this.getItem(r, c).uri
      return this.srcList[this.getIndex(r, c)]
    },
    getImageTitle(r, c) {
      return tool.getFileName(this.getItem(r, c)['name'])
    },
    adjustDisplay() {
      this.Mobile.on = tool.isMobile()
      this.Mobile.isVertical = tool.isVerticalScreen()
      if (this.Mobile.on) {
        if (this.Mobile.isVertical)
          [this.span, this.col, this.gutter] = [12, 2, 12]
        else
          [this.span, this.col, this.gutter] = [6, 4, 20]
      } else {// PC
        [this.span, this.col, this.gutter] = [4, 5, 50]
      }
    }
  },
  computed: {
    row() {
      return Math.ceil(this.list.length / this.col)
    },
    isLandscapeMobile() {
      return this.Mobile.on && !this.Mobile.isVertical
    }
  },
  created() {
    this.getImageList()
    this.adjustDisplay()
    addEventListener('resize', this.adjustDisplay)
  },
  unmounted() {
    removeEventListener('resize', this.adjustDisplay)
  }
}
</script>

<style scoped>
.time {
  font-size: 12px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.button {
  padding: 10px;
  min-height: auto;
}

.image {
  width: 100%;
  /*display: block;*/
}

.row-bg {
  background-color: rgba(65, 64, 64, 0.5);
}

.ellipsis { /*省略过长文本*/
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.editLabel { /*不能覆盖内部的el-input css*/
  font-size: 15pt;
  font-weight: bold;
}
</style>